import { Component, NgZone, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Subscription } from 'rxjs';
import { AppConfigService } from './main/app-config.service';
import { AppConstants } from './common/constants/app-constants';
import { DataService } from './common/services/data.service';
import { SharedService } from './common/services/shared.service';
import { TokenService } from './common/services/token.service';
import { UserCacheService } from './common/services/user-cache.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnDestroy {
	title = 'sae';
	idleState = 'Not started.';
	timedOut = false;
	modalMsg = '';
	isLoggedIn = false;
	landingData: any;
	displaySpinner = false;
	dashboardServiceSubscription: Subscription;
	onIdleEnd: Subscription;
	isUserLoggedIn: Subscription;
	onTimeout: Subscription;
	onIdleStart: Subscription;
	onTimeoutWarning: Subscription;
	//refreshTokenInstance: Subscription;
	userLoggedInstance: Subscription;
	logoutObs: Subscription;
	//refreshTokenObs:Subscription;
	public environment: any;
	errorMessages: {
		STORY_ERR_001: 'User doesnt have access to any stories',
		USER_ERR_001: 'User not found'
	};
	errorMsg: any;
	//refreshTokenInterval: any;
	ngOnDestroy() {
		if (this.onIdleEnd) {
			this.onIdleEnd.unsubscribe();
		}
		if (this.isUserLoggedIn) {
			this.isUserLoggedIn.unsubscribe();
		}
		if (this.onTimeout) {
			this.onTimeout.unsubscribe();
		}
		if (this.onIdleStart) {
			this.onIdleStart.unsubscribe();
		}
		if (this.onTimeoutWarning) {
			this.onTimeoutWarning.unsubscribe();
		}
		// if (this.refreshTokenInstance) {
		// 	this.refreshTokenInstance.unsubscribe();
		// }
		if (this.userLoggedInstance) {
			this.userLoggedInstance.unsubscribe();
		}
		if (this.logoutObs) {
			this.logoutObs.unsubscribe();
		}
		// if (this.refreshTokenObs) {
		// 	this.refreshTokenObs.unsubscribe();
		// }
		if (this.dashboardServiceSubscription) {
			this.dashboardServiceSubscription.unsubscribe();
		}
	}

	constructor(public userCacheService: UserCacheService,
		public dataService: DataService,
		public tokenService: TokenService,
		public idle: Idle,
		public logoutService: TokenService,
		public router: Router,
		private sharedService: SharedService,
		private ngZone: NgZone,
		private appConfigService: AppConfigService) {
		this.environment = this.appConfigService.getConfig();
		this.isUserLoggedIn = this.dataService.userLoggedInstance.subscribe((data) => {
			if (data) {
				setTimeout(() => {this.isLoggedIn = true}, 0);
				this.LandingApiCall();
				idle.watch()
				this.timedOut = false;
			} else {
				this.isLoggedIn = false;
				idle.stop();
				// if (this.refreshTokenInterval)
				// 	clearInterval(this.refreshTokenInterval);
			}

		})

		// sets an idle timeout of 15 seconds.
		idle.setIdle(this.environment?.idleTimeLength ?? 900);
		// sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
		idle.setTimeout(this.environment?.sessionTimeoutLength ?? 300);
		// sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
		idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

		this.onIdleEnd = idle.onIdleEnd.subscribe(() => {
			this.idleState = 'No longer idle.'
			console.log(this.idleState);
			this.reset();
		});

		this.onTimeout = idle.onTimeout.subscribe(() => {
			this.closeIdleModal();
			this.idleState = 'Timed out!';
			this.timedOut = true;
			console.log(this.idleState);
			this.logout();
		});

		this.onIdleStart = idle.onIdleStart.subscribe(() => {
			this.idleState = 'You\'ve gone idle!'
			console.log(this.idleState);
			this.openIdleModal();
		});

		this.onTimeoutWarning = idle.onTimeoutWarning.subscribe((countdown) => {
			this.idleState = 'You will time out in ' + countdown + ' seconds!'
			this.modalMsg = 'Your session will expire in ' + countdown + ' seconds.'
			console.log(this.idleState);
		});


		// Reload event binding to allow caching of data despite page refresh.
		window.onbeforeunload = () => {
			userCacheService.backupToLocalStorage();
		};
		// this.refreshTokenInstance = this.dataService.refreshTokenInstance.subscribe(data => {
		// 	if (data) {
		// 		this.refreshToken();
		// 	}
		// });
		this.router.events.subscribe(event => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		});
	}

	LandingApiCall(): void {
		this.landingData = this.userCacheService.getUserData('landingData')
		if (!this.landingData) {
			this.displaySpinner = true;
			this.dashboardServiceSubscription = this.sharedService.universityLandingAPI().subscribe((data: any) => {
				setTimeout(() => {this.displaySpinner = false}, 0);
				if (data && data.status === AppConstants.SUCCESS_STATUS) {
					this.landingData = data;
					this.userCacheService.setUserData('landingData', data);
				} else {
					this.errorMsg = this.errorMessages[data.errorMessage];
				}
			}, err => {
				this.displaySpinner = false;
				console.log(err);
			});
		}

	}

	// refreshToken() {
	// 	this.refreshTokenInterval = setInterval(async () => {
	// 		await this.invokeRefreshTokenApi();
	// 	}, environment.refreshTokenTimeInterval);
	// }

	// async invokeRefreshTokenApi() {
	// 	try {
	// 		let response: any = await this.tokenService.refreshToken();
	// 		if (response && response.status === 'SUCCESS') {
	// 			this.userCacheService.setUserData(AppConstants.TOKEN, response.token);
	// 		} else {
	// 			this.logout();
	// 		}
	// 	} catch (error) {
	// 		this.logout();
	// 	}
	// }

	reset() {
		this.idle.watch();
		//xthis.idleState = 'Started.';
		this.timedOut = false;
	}

	closeIdleModal(): void {
		const modal = document.getElementById('timeOutModal');
		modal.removeAttribute('open');
	}

	openIdleModal(): void {
		const modal = document.getElementById('timeOutModal');
		modal.setAttribute('open', '');
	}

	stay() {
		//this.childModal.hide();
		this.closeIdleModal();
		this.reset();
	}

	logout() {
		this.closeIdleModal();
		this.logoutObs = this.logoutService.logout().subscribe(data => {
			this.userCacheService.eraseAllUserData();
			localStorage.clear();
			this.dataService.userLoggedIn(false);
			this.dataService.allAccountdropdownChangeAnnouncment({ storyId: '', searchKeyword: '', route: '', storyValue: '' })
			this.ngZone.run(()=> { window.location.href = '/logout'; });
			this.dataService.changeStory('', '', '');
		}, err => {
			this.userCacheService.eraseAllUserData();
			localStorage.clear();
			this.dataService.userLoggedIn(false);
			window.location.href = '/logout';
		})
	}

}
